import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const withDialog = (WrappedComponent, title = "Dialog Title") => {
  return ({ open, onClose, ...props }) => {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: "30px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" className="typography_heading head">
            {title}
          </Typography>
          <IconButton sx={{ ml: 2 }} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <WrappedComponent {...props} />
        </DialogContent>
      </Dialog>
    );
  };
};

export default withDialog;
